import "@arco-design/web-react/es/Popconfirm/style";
import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _IconBook from "@arco-design/web-react/icon/react-icon/IconBook";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { GlobalContext } from '@/context';
import request from '@/utils/request';
import useLocale from '@/utils/useLocale';
import { removeAccessToken, removeRefreshToken } from '@/utils/token';
import Logo from '@/assets/logo@zzb.svg';
import IconButton from './IconButton';
import Profile from '../Profile';
import styles from './style/index.module.less';
import defaultLocale from '@/locale';
const Language = [{
  label: '简体中文',
  value: 'zh-CN'
}, {
  label: 'English(US)',
  value: 'en-US'
}];
function Navbar({
  show
}) {
  const t = useLocale();
  const history = useHistory();
  const userInfo = useSelector(state => state.userInfo);
  const operRules = useSelector(state => state.operRules);
  const userLoading = useSelector(state => state.userLoading);
  const dispatch = useDispatch();
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  function logout() {
    request.post('/v1/user/logout').then(res => {
      const {
        code,
        message
      } = res.data;
      _Message.success(message);
    }).finally(() => {
      removeAccessToken();
      removeRefreshToken();
      window.location.href = '/login';
    });
  }
  useEffect(() => {
    dispatch({
      type: 'update-userInfo',
      payload: {
        userInfo: {
          ...userInfo
        }
      }
    });
    dispatch({
      type: 'update-oper-rules',
      payload: {
        operRules: [...operRules]
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement("a", {
    href: "http://www.zhizaoband.com/home",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      display: 'inline-flex',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-name']
  }, userInfo?.corp_name || ''))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: t['menu.navbar.help']
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(_IconBook, null),
    onClick: () => history.push('/help')
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: Language,
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value];
      const langLabel = Language.find(item => item.value === value);
      _Message.info(`${nextLang['message.lang.tips']}${langLabel.label}`);
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? t['settings.navbar.theme.toDark'] : t['settings.navbar.theme.toLight']
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }))), /*#__PURE__*/React.createElement(Profile, null), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Popconfirm, {
    title: t['menu.navbar.logout'],
    content: t['menu.navbar.logout.description'],
    okText: t['menu.navbar.logout.ok'],
    cancelText: t['menu.navbar.logout.cancel'],
    onOk: () => {
      logout();
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(_IconPoweroff, null),
    status: "danger"
  })))));
}
export default Navbar;